import React from "react"

export default function Absences() {
  return (
    <symbol id="svg-absences" viewBox="0 0 36 36">
      <path
        d="M14 6C10.68 6 8 8.68 8 12C8 15.32 10.68 18 14 18C17.32 18 20 15.32 20 12C20 8.68 17.32 6 14 6ZM14 15C12.26 15 11 13.74 11 12C11 10.26 12.26 9 14 9C15.74 9 17 10.26 17 12C17 13.74 15.74 15 14 15Z"
        fill="currentColor"
      />
      <path
        d="M2 25C2 21.01 9.99 19 14 19C18.01 19 26 21.01 26 25V30H23V25C23 24.04 18.46 22 14 22C9.54 22 5 24.04 5 25V30H2V25Z"
        fill="currentColor"
      />
      <path
        d="M31.62 12.26L29.5 14.38L27.38 12.26L25.26 14.38L27.38 16.5L25.26 18.62L27.38 20.74L29.5 18.62L31.62 20.74L33.74 18.62L31.62 16.5L33.74 14.38L31.62 12.26Z"
        fill="currentColor"
      />
    </symbol>
  )
}
